 
import NavBar from './Components/NavBar';
import Search from './Components/Search';
function App() {
  return (
    <>
      <NavBar />
      <Search />
    </>
  );
}

export default App;
